import { trackTemplate } from '../../utils/tracking';

/**
 * search result click
 * @param string text
 */
export function clickSearchResult(text, action) {
  return trackTemplate({
    event: 'genericEvent',
    data: {
      category: 'Search',
      action,
      label: text,
      value: '0',
    },
  });
}
